import _ from "lodash";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React from "react";
import { connect } from "react-redux";

import AppMenuBar from "../../components/appMenu/AppMenuBar";
import AppTitleBarView from "../../components/appTitleBar";
import clipboardActions from "../../constants/clipboardActions";
import PubSubTopics from "../../constants/pubSubTopics";
import { uiStateSelectors } from "../../modules/uiState";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import handleClipboard from "./handleClipboard";
import selectors from "./selectors";

// Create a list of actions that have to be handled natively...
const nativelyHandledActions = [
  nativeCommsBroadcastMessageTypes.FILE_NEW,
  nativeCommsBroadcastMessageTypes.FILE_OPEN,
  nativeCommsBroadcastMessageTypes.FILE_OPEN_RECENT,
  nativeCommsBroadcastMessageTypes.FILE_CLEAR_RECENT,
  nativeCommsBroadcastMessageTypes.FILE_SAVE,
  nativeCommsBroadcastMessageTypes.FILE_SAVE_AS,
  nativeCommsBroadcastMessageTypes.FILE_IMPORT_CSV,
  nativeCommsBroadcastMessageTypes.FILE_CLOSE,
  nativeCommsBroadcastMessageTypes.FILE_CLOSE_ALL,
  nativeCommsBroadcastMessageTypes.CHECK_FOR_UPDATE,
  nativeCommsBroadcastMessageTypes.SHOW_HELP,
  nativeCommsBroadcastMessageTypes.SHOW_REGISTRATION_MODAL,
  nativeCommsBroadcastMessageTypes.FILE_EXIT
];

const onCloseWindow = () => {
  PubSub.publish(PubSubTopics.sendNativeMessage, {
    msg: nativeCommsBroadcastMessageTypes.CLOSE_WINDOW
  });
};
const onMinimizeWindow = () => {
  PubSub.publish(PubSubTopics.sendNativeMessage, {
    msg: nativeCommsBroadcastMessageTypes.MINIMIZE_WINDOW
  });
};
const onMaximizeWindow = _isMaximized => {
  PubSub.publish(PubSubTopics.sendNativeMessage, {
    msg: nativeCommsBroadcastMessageTypes.MAXIMIZE_WINDOW
  });
};

const AppMenu = props => {
  const onItemClick = (msg, data) => {
    if (_.includes(nativelyHandledActions, msg)) {
      // TODO: determine if we should wrap this in conditional compile...?
      if (msg === nativeCommsBroadcastMessageTypes.FILE_NEW && !isNativeCommsInstalled()) {
        window.open(window.location.href);
        return;
      }
      // Send it to be handled natively
      PubSub.publish(PubSubTopics.sendNativeMessage, { msg, data });
    } else if (_.includes(clipboardActions, msg)) {
      handleClipboard(msg);
    } else {
      // Or otherwise handle it within Javascript directly
      window.nativeCommsReceiver(msg, data);
    }
  };

  const appMenuView = <AppMenuBar menuItems={props.menuItems} depth={0} onItemClick={onItemClick} />;

  const title = props.fileName ? `${props.fileName} - Aeon Timeline` : "Aeon Timeline";

  const result = (
    <AppTitleBarView
      menuBar={appMenuView}
      title={title}
      showMaximize={true}
      showMinimize={true}
      showClose={true}
      onClose={onCloseWindow}
      onMinimize={onMinimizeWindow}
      onMaximize={onMaximizeWindow}
    />
  );

  return result;
};

AppMenu.propTypes = {
  menuItems: PropTypes.object,
  fileName: PropTypes.string,

  isFocusedFieldEditable: PropTypes.bool,

  // Test Code
  testPrintState: PropTypes.object
};

const mapStateToProps = (state, props) => {
  const result = {
    menuItems: selectors.getMenuItems(state, props.isFocusedFieldEditable),
    fileName: uiStateSelectors.getFileName(state.present),

    // TODO: Test Code:
    // If we are in the browser, then we want to be able to send the complete state
    // through to printing.
    testPrintState: isNativeCommsInstalled() ? null : state.present
  };
  return result;
};

const mapDispatchToProps = _dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AppMenu);
